export default __webpack_public_path__ + "static/media/caleb-03-icon.224a0e18.svg";